export const common = {
  // Navigation
  home: 'Home',
  services: 'Services',
  projects: 'Projects',
  team: 'Team',
  pricing: 'Pricing',
  faq: 'FAQ',
  contact: 'Contact',
  backToHome: 'Back to Home',
  
  // Hero Section
  heroTag: 'Innovative Software Solutions for Your Business',
  heroTitle1: 'Debug, Develop, Deploy',
  heroTitle2: 'With Confidence',
  heroDescription: 'We transform your ideas into powerful digital products with cutting-edge technology and expert development teams',
  startProject: 'Start Your Project',
  exploreServices: 'Explore Services',
  projectsCompleted: 'Projects Completed',
  clientSatisfaction: 'Client Satisfaction',
  aiSupport: 'AI Support Available',
  
  // Services Section
  ourServices: 'Our Services',
  servicesTitle: 'Comprehensive Development Solutions',
  servicesDescription: 'From debugging to deployment, we offer a full range of services to help you build and maintain exceptional software.',
  
  service1Title: 'Bug Fixing & Debugging',
  service1Description: 'Expert debugging services to identify and fix issues quickly. Our team uses advanced tools and AI assistance to resolve bugs efficiently.',
  service1Feature1: 'Code Analysis',
  service1Feature2: 'Error Tracking',
  service1Feature3: 'Performance Testing',
  service1Feature4: 'Root Cause Analysis',
  
  service2Title: 'Custom Development',
  service2Description: 'Build custom applications and features tailored to your needs. From web apps to mobile solutions, we deliver quality code.',
  service2Feature1: 'Web Applications',
  service2Feature2: 'Mobile Apps',
  service2Feature3: 'API Development',
  service2Feature4: 'Database Design',
  
  service3Title: 'Cloud Services',
  service3Description: 'Cloud migration, deployment, and management with AWS, Azure, and Google Cloud platforms',
  service3Feature1: 'Cloud Migration',
  service3Feature2: 'Infrastructure Setup',
  service3Feature3: 'Scalability Solutions',
  service3Feature4: 'Cloud Monitoring',
  
  service4Title: 'Workplace Automation',
  service4Description: 'Automate repetitive tasks and workflows to boost productivity. Custom scripts and tools designed for your specific needs.',
  service4Feature1: 'Task Automation',
  service4Feature2: 'Workflow Integration',
  service4Feature3: 'Data Processing',
  service4Feature4: 'Report Generation',
  
  service5Title: 'Performance Optimization',
  service5Description: 'Optimize your applications for speed and efficiency. Comprehensive analysis and improvements for better user experience.',
  service5Feature1: 'Load Time Reduction',
  service5Feature2: 'Database Optimization',
  service5Feature3: 'Code Refactoring',
  service5Feature4: 'Caching Strategies',
  
  service6Title: 'Security Audits',
  service6Description: 'Comprehensive security reviews to protect your applications. Identify vulnerabilities and implement best practices.',
  service6Feature1: 'Vulnerability Scanning',
  service6Feature2: 'Code Review',
  service6Feature3: 'Security Patches',
  service6Feature4: 'Compliance Check',
  
  // Why Choose Section
  whyChooseTitle: 'Why Choose Debug?',
  whyChooseDescription: 'We combine technical expertise with business insight to deliver exceptional software solutions',
  
  whyFeature1Title: 'Expert Team',
  whyFeature1Description: 'Highly skilled developers, designers, and engineers with years of industry experience',
  
  whyFeature2Title: 'Timely Delivery',
  whyFeature2Description: 'Committed to meeting deadlines with efficient project management and development processes',
  
  whyFeature3Title: 'Dedicated Support',
  whyFeature3Description: 'Ongoing technical support and maintenance to ensure your software runs smoothly',
  
  whyFeature4Title: 'Quality Assurance',
  whyFeature4Description: 'Rigorous testing and quality control to deliver reliable and high-performance solutions',
  
  // Projects Section
  ourWork: 'Our Work',
  projectsTitle: 'Success Stories & Projects',
  projectsDescription: 'Explore our portfolio of successful projects across various industries and technologies.',
  
  // Project Filters
  filterAll: 'All',
  filterWeb: 'Web',
  filterMobile: 'Mobile',
  filterEnterprise: 'Enterprise',
  
  web1Title: 'North Africa Agriculture',
  web1Category: 'Web Development',
  web1Description: 'A corporate website for a company specializing in sustainable agricultural solutions, showcasing its services and products while highlighting its expertise and contribution to the development of the agricultural sector across North Africa.',  
  
  web2Title: 'We Buy Your Car - Germany',
  web2Category: 'Web Development',
  web2Description: 'A German platform that buys used cars directly from customers with instant online evaluation, secure payment, and free pickup',
  
  web3Title: 'Horeca Smart Academy',
  web3Category: 'Web Development',
  web3Description: 'A training platform specializing in hospitality (HORECA), offering professional courses in food & beverage and restaurant management.',
  
  mobile1Title: '5vix System App',
  mobile1Category: 'Mobile Development',
  mobile1Description: 'meticulously crafted to enhance your performance, amplify your results, and propel you towards unparalleled success',
  
  mobile2Title: 'Texio ERP APP',
  mobile2Category: 'Mobile Development',
  mobile2Description: 'Texio is a powerful management system designed specifically for textile factories',
  
  mobile3Title: 'Horeca In',
  mobile3Category: 'Mobile Development',
  mobile3Description: 'A mobile app that connects job seekers with restaurants and food-industry employers, allowing users to browse job listings and apply directly through the app.',
  
  mobile4Title: '5vix Fit',
  mobile4Category: 'Mobile Development',
  mobile4Description: 'The official member app for 5vix gyms. It allows gym members to easily check their subscriptions, track their attendance, and stay updated with gym activities — all in one place.',
  

  enterprise1Title: '5vix Gym System',
  enterprise1Category: 'Enterprise Solution',
  enterprise1Description: 'A comprehensive gym platform for member management, subscriptions, and class scheduling',
  
  enterprise2Title: 'Textile ERP System',
  enterprise2Category: 'Enterprise Solution',
  enterprise2Description: 'Texio is a comprehensive ERP system built for the textile industry, helping you manage production, inventory, sales, purchasing, and operations in one integrated platform.',

  enterprise3Title: 'WhatsApp AI Agent',
  enterprise3Category: 'Enterprise Solution',
  enterprise3Description: 'Smart replies, bulk messaging, and deep insights — one platform that handles every conversation like a pro.',
  
  enterprise4Title: 'AI-Medical Analysis',
  enterprise4Category: 'Enterprise Solution',
  enterprise4Description: 'Intelligent medical imaging system for automated detection of fractures, osteoarthritis, lung abnormalities, scoliosis, and dental conditions.',

  // What We Do Section
  whatWeDo: 'What We Do',
  whatWeDoTag: 'Our Expertise',
  whatWeDoTitle: 'What We Do',
  whatWeDoDescription: 'We build intelligent digital solutions, automate workflows, and help businesses scale faster using cutting-edge technology.',
  whatWeDoPillar1Title: 'Smart Digital Solutions',
  whatWeDoPillar1Description: 'We design and develop custom software that solves real business challenges. From web platforms to mobile applications, every product is built for performance, scalability, and long-term growth.',
  whatWeDoPillar1Feature1: 'Custom Web & Mobile Apps',
  whatWeDoPillar1Feature2: 'API & System Integration',
  whatWeDoPillar1Feature3: 'AI-Powered Features',
  whatWeDoPillar1Feature4: 'Scalable Architecture',
  whatWeDoPillar2Title: 'Workflow Automation',
  whatWeDoPillar2Description: 'We eliminate repetitive tasks and streamline operations by automating core business processes, enabling your team to focus on higher-value work.',
  whatWeDoPillar2Feature1: 'Task & Process Automation',
  whatWeDoPillar2Feature2: 'Data Pipeline Integration',
  whatWeDoPillar2Feature3: 'Smart Reporting Systems',
  whatWeDoPillar2Feature4: 'Cross-Platform Synchronization',
  whatWeDoPillar3Title: 'Scale Efficiently',
  whatWeDoPillar3Description: 'We help businesses grow without friction. From infrastructure to optimization, we ensure systems are built to scale reliably, securely, and cost-effectively.',
  whatWeDoPillar3Feature1: 'Cloud Infrastructure Setup',
  whatWeDoPillar3Feature2: 'Performance Optimization',
  whatWeDoPillar3Feature3: 'Security & Compliance',
  whatWeDoPillar3Feature4: 'Ongoing Support & Maintenance',
  whatWeDoCtaTitle: 'Ready to Transform Your Business?',
  whatWeDoCtaDescription: 'Let\'s build the digital foundation that drives your growth — from idea to execution.',
  
  // Team Section
  ourTeam: 'Our Team',
  teamTitle: 'Meet the Experts',
  teamDescription: 'Our talented team of developers, engineers, and specialists dedicated to delivering exceptional results.',
  
  member1Name: 'Rashad Elbanna',
  member1Role: 'CEO & Founder',
  member1Bio: '9+ years of experience in software development and business leadership',
  
  member2Name: 'Fathy Darwish',
  member2Role: 'CTO & Founder',
  member2Bio: 'Delivering scalable, high-impact digital solutions Focused on practical innovation and sustainable value',
  
  member3Name: 'Mahmoud Yakout',
  member3Role: 'Software Developer',
  member3Bio: 'Developing high-performance mobile applications Expertise in cross-platform solutions and native features',
  
  member4Name: 'Ruqaya Nabil',
  member4Role: 'Data Coordinator',
  member4Bio: 'Specialist in data collection, organization, and client communication to ensure accurate and up-to-date records.',
  
  member5Name: 'Farida Saeed',
  member5Role: 'UX/UI Designer',
  member5Bio: 'Creative designer with expertise in creating intuitive and engaging user experiences',
  

  // Pricing Section
  pricingPlans: 'Pricing Plans',
  pricingTitle: 'Simple, Transparent Pricing',
  pricingDescription: 'Choose the plan that fits your needs. All plans include quality assurance and satisfaction guarantee.',
  
  plan1Name: 'Starter',
  plan1Price: '99',
  plan1Period: 'per project',
  plan1Description: 'Perfect for small bug fixes and quick improvements',
  
  plan2Name: 'Professional',
  plan2Price: '299',
  plan2Period: 'per project',
  plan2Description: 'Ideal for custom development and complex features',
  mostPopular: 'Most Popular',
  
  plan3Name: 'Enterprise',
  plan3Price: 'Custom',
  plan3Period: 'contact us',
  plan3Description: 'Comprehensive solutions for large-scale projects',
  
  planFeature1: 'Bug Fixing & Debugging',
  planFeature2: 'Code Review',
  planFeature3: 'Performance Analysis',
  planFeature4: 'Email Support',
  planFeature5: '48-hour Response Time',
  planFeature6: 'Basic Documentation',
  planFeature7: 'Everything in Starter',
  planFeature8: 'Custom Development',
  planFeature9: 'AI Code Generation',
  planFeature10: 'Priority Support',
  planFeature11: '24-hour Response Time',
  planFeature12: 'Detailed Documentation',
  planFeature13: 'Code Optimization',
  planFeature14: 'Security Audit',
  planFeature15: 'Everything in Professional',
  planFeature16: 'Dedicated Team',
  planFeature17: 'Workplace Automation',
  planFeature18: '24/7 Support',
  planFeature19: 'Instant Response',
  planFeature20: 'Complete Documentation',
  planFeature21: 'Ongoing Maintenance',
  planFeature22: 'Training & Consultation',
  planFeature23: 'Custom SLA',
  
  getStarted: 'Get Started',
  customSolution: 'Need a custom solution? We\'re here to help.',
  contactQuote: 'Contact us for a personalized quote →',
  
  // FAQ Section
  faqTag: 'FAQ',
  faqTitle: 'Frequently Asked Questions',
  faqDescription: 'Find answers to common questions about our services and process.',
  
  faq1Question: 'How quickly can you fix bugs in my application?',
  faq1Answer: 'Our response time depends on the complexity and urgency of the issue. For critical bugs, we can start working within hours. Most bug fixes are completed within 24-48 hours. We offer priority support for urgent issues.',
  
  faq2Question: 'What technologies and frameworks do you work with?',
  faq2Answer: 'We work with a wide range of modern technologies to deliver comprehensive software solutions, including frontend: React, Vue, Angular, HTML5, CSS3, CSS, Bootstrap, jQuery; backend: Node.js, Express.js, Python (Django, Flask), Java (Spring Boot), PHP (Laravel, Symfony); mobile applications: React Native, Flutter, Swift, Kotlin; cloud platforms: AWS, Microsoft Azure, Google Cloud Platform, Firebase, DigitalOcean; databases & storage: MySQL, PostgreSQL, MongoDB, Firebase Firestore, Oracle, Microsoft SQL Server; DevOps & tools: Docker, Git / GitHub / GitLab, Jenkins, CircleCI, Terraform, CI/CD, RESTful APIs, GraphQL, WebSockets; UI/UX design tools: Figma, Adobe XD, Sketch, InVision, Zeplin.',
  
  faq3Question: 'Do you provide ongoing maintenance and support?',
  faq3Answer: 'Yes, we offer ongoing maintenance packages tailored to your needs. This includes regular updates, security patches, performance monitoring, and technical support. We can create a custom maintenance plan based on your requirements.',
  
  faq4Question: 'How does AI-powered code generation work?',
  faq4Answer: 'Our AI tools analyze your requirements and existing codebase to generate optimized, production-ready code. This accelerates development time while maintaining high quality standards. All AI-generated code is reviewed by our expert developers before delivery.',
  
  faq5Question: 'What is your pricing model?',
  faq5Answer: 'We offer flexible pricing based on project scope and complexity. You can choose from our standard packages or request a custom quote for larger projects. All pricing is transparent with no hidden fees, and we provide detailed estimates before starting work.',
  
  faq6Question: 'Do you sign NDAs and protect intellectual property?',
  faq6Answer: 'Absolutely. We take confidentiality seriously and are happy to sign NDAs before discussing your project. All code and intellectual property rights are transferred to you upon project completion. We maintain strict security protocols to protect your data.',
  
  faq7Question: 'What flagship platforms and enterprise systems does Debug offer?',
  faq7Answer: 'Debug powers five production-ready platforms: (1) 5vix Gym System for fitness club & membership management, (2) 5vix Fit member mobile app, (3) Texio ERP built specifically for textile and garment manufacturing, (4) WhatsApp AI Agent (Debug / Wyzon) for 24/7 automated sales and support, and (5) AI-Medical Analysis for automated diagnostic radiology.',
  
  faq8Question: 'How do you guarantee code quality and fast issue resolution?',
  faq8Answer: 'We apply systematic Root Cause Analysis rather than temporary patches, backed by automated regression tests, OWASP security compliance, and performance profiling. Our engineers begin emergency diagnosis within 2 hours with comprehensive technical audit reports.',
  
  stillQuestions: 'Still have questions?',
  stillQuestionsDescription: 'Can\'t find the answer you\'re looking for? Our team is here to help.',
  contactSupport: 'Contact Support',
  
  // Contact Section
  getInTouch: 'Get In Touch',
  ctaTitle: 'Ready to Start Your Project?',
  ctaDescription: 'Let\'s discuss how we can help you build, debug, and optimize your applications. Our team is ready to turn your ideas into reality.',
  
  emailUs: 'Email Us',
  callUs: 'Call Us',
  availability: 'Availability',
  availabilityText: '24/7 AI Support Available',
  
  fullName: 'Full Name',
  emailAddress: 'Email Address',
  companyName: 'Company Name',
  projectDetails: 'Project Details',
  sendMessage: 'Send Message',
  sending: 'Sending...',
  thankYou: 'Thank you! We\'ll get back to you soon.',
  
  // Flagship Systems & Smart Routing
  flagshipSectionTag: 'Flagship Systems & Platforms',
  flagshipTitle: 'Production-Grade Industry Platforms',
  flagshipDescription: 'Full-featured enterprise solutions powering fitness centers, textile manufacturing, healthcare AI imaging, and 24/7 AI customer operations.',
  launchSystem: 'Launch & Explore System',
  exploreSystem: 'Explore System',
  downloadApp: 'Download App',
  visitWebPlatform: 'Cloud Web Platform',
  interestedSystem: 'Interested System or Solution',
  systemGeneral: 'General Custom Development & Debugging',
  systemWhatsappAi: 'WhatsApp AI Agent (Debug / Wyzon)',
  system5vixGym: '5vix Gym Management System',
  system5vixFit: '5vix Fit Member Mobile App',
  systemAiMedical: 'AI-Medical Diagnostic Analysis (5vix AI)',
  systemTextileErp: 'Textile Manufacturing ERP (Texio)',
  recommendedProductBadge: 'Recommended Solution for this Topic',
  
  // Footer
  footerDescription: 'Expert debugging and development solutions powered by AI technology and experienced professionals.',
  servicesFooter: 'Services',
  bugFixing: 'Bug Fixing & Debugging',
  customDev: 'Custom Development',
  cloudServices: 'Cloud Services',
  aiCodeGen: 'AI Code Generation',
  workplaceAuto: 'Workplace Automation',
  perfOptimization: 'Performance Optimization',
  
  company: 'Company',
  aboutUs: 'About Us',
  ourWorkFooter: 'Our Work',
  pricingFooter: 'Pricing',
  faqFooter: 'FAQ',
  contactFooter: 'Contact',
  
  contactInfo: 'Contact Info',
  copyright: '© 2025 Debug. All Rights Reserved',
  privacyPolicy: 'Privacy Policy',
  termsOfService: 'Terms of Service',
  poweredBy: 'Powered by Debug',
  
  // Privacy Policy
  lastUpdated: "Last Updated",
  introductionTitle: "Introduction",
  introductionText: "At Debuging, we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.",
  informationWeCollect: "Information We Collect",
  informationWeCollectText: "We collect information that you provide directly to us, including:",
  personalInfo: "Personal information such as name, email address, and phone number",
  technicalInfo: "Technical information about your device and browsing activity",
  usageData: "Usage data and analytics about how you interact with our services",
  howWeUseInfo: "How We Use Your Information",
  howWeUseInfoText: "We use the information we collect to:",
  provideServices: "Provide, maintain, and improve our services",
  improveServices: "Develop new features and functionality",
  communicateWithYou: "Communicate with you about our services",
  sendUpdates: "Send you updates, newsletters, and marketing materials",
  protectRights: "Protect our rights and prevent fraud",
  dataSecurity: "Data Security",
  dataSecurityText: "We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.",
  thirdPartyServices: "Third-Party Services",
  thirdPartyServicesText: "We may use third-party service providers to help us operate our business and provide services to you. These providers have access to your information only to perform specific tasks on our behalf and are obligated to protect your information.",
  yourRights: "Your Rights",
  yourRightsText: "You have the right to:",
  accessData: "Access and receive a copy of your personal data",
  correctData: "Correct inaccurate or incomplete information",
  deleteData: "Request deletion of your personal information",
  restrictProcessing: "Restrict or object to processing of your data",
  dataPortability: "Request data portability",
  cookies: "Cookies and Tracking",
  cookiesText: "We use cookies and similar tracking technologies to track activity on our website and store certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.",
  changesToPolicy: "Changes to This Policy",
  changesToPolicyText: "We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the 'Last Updated' date.",
  contactUs: "Contact Us",
  contactUsText: "If you have any questions about this Privacy Policy, please contact us:",
  email: "Email",
  phone: "Phone",
  
  // Terms of Service
  acceptanceOfTerms: "Acceptance of Terms",
  acceptanceOfTermsText: "By accessing and using Debuging's services, you accept and agree to be bound by the terms and provisions of this agreement. If you do not agree to these terms, please do not use our services.",
  servicesDescriptionText: "Debuging provides software development, web development, mobile app development, cloud solutions, and IT consulting services. We reserve the right to modify, suspend, or discontinue any aspect of our services at any time.",
  userResponsibilities: "User Responsibilities",
  userResponsibilitiesText: "As a user of our services, you agree to:",
  provideAccurateInfo: "Provide accurate and complete information",
  maintainSecurity: "Maintain the security of your account credentials",
  complyWithLaws: "Comply with all applicable laws and regulations",
  notMisuse: "Not misuse or abuse our services",
  intellectualProperty: "Intellectual Property",
  intellectualPropertyText: "All content, features, and functionality of our services are owned by Debuging and are protected by international copyright, trademark, and other intellectual property laws. You may not reproduce, distribute, or create derivative works without our express written permission.",
  paymentTerms: "Payment Terms",
  paymentTermsText: "Payment terms are agreed upon before project commencement. All fees are non-refundable unless otherwise specified in writing. Late payments may result in suspension of services and additional fees.",
  limitationOfLiability: "Limitation of Liability",
  limitationOfLiabilityText: "Debuging shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use our services. Our total liability shall not exceed the amount paid by you for the services in question.",
  termination: "Termination",
  terminationText: "We reserve the right to terminate or suspend your access to our services immediately, without prior notice, for any reason, including breach of these Terms of Service.",
  governingLaw: "Governing Law",
  governingLawText: "These Terms shall be governed by and construed in accordance with the laws of Egypt, without regard to its conflict of law provisions.",
  changesToTerms: "Changes to Terms",
  changesToTermsText: "We reserve the right to modify these terms at any time. We will notify users of any material changes by posting the new Terms of Service on this page.",
  contactUsTermsText: "If you have any questions about these Terms of Service, please contact us:",
  
  // Blog Section
  blog: 'Blog',
  blogTitle: 'Software Development Insights',
  blogTitleAr: 'رؤى وموارد تطوير البرمجيات',
  blogDescription: 'Expert articles on software debugging, custom development, and cloud services for Egyptian businesses.',
  blogDescriptionAr: 'مقالات خبيرة حول تصحيح البرمجيات، التطوير المخصص، والخدمات السحابية للشركات المصرية.',
  readMore: 'Read more',
  backToBlog: 'Back to Blog',
  articleNotFound: 'Article Not Found',
  relatedArticles: 'Related Articles',
  
  // Service Pages
  whatWeOffer: 'What We Offer',
  whyChooseDebug: 'Why Choose Debug?',
  getQuote: 'Get a Quote',
  relatedServices: 'Related Services',
};
